import { motion } from 'framer-motion';

type Tone = 'dark' | 'light';
interface CardValue { tone?: Tone; opacity?: number }

interface Props {
  value?: CardValue;
  onChange: (value: CardValue) => void;
}

/**
 * Recuadro detrás del titular del hero (solo Pantalla completa). Es un panel
 * propio, distinto de la imagen de fondo: separa el texto del fondo para que el
 * titular no se mezcle. Controla un prop objeto `titleCard` { tone, opacity }.
 * opacity 0 = sin recuadro.
 */
export function TitleCardField({ value, onChange }: Props) {
  const tone: Tone = value?.tone ?? 'dark';
  const opacity = typeof value?.opacity === 'number' ? value.opacity : 0;
  const on = opacity > 0;

  const setTone = (t: Tone) => onChange({ tone: t, opacity });
  const setOpacity = (o: number) => onChange({ tone, opacity: o });

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22, ease: 'easeOut' }}
      className="rounded-lg border border-ui-border bg-ui-surface p-3.5 space-y-3"
    >
      <p className="text-sm text-ui-text-subtle leading-snug">
        Pon un recuadro detrás del texto para que el titular no se mezcle con la imagen.
      </p>

      {/* Tono del recuadro */}
      <div className="flex gap-2">
        {([['dark', 'Oscuro'], ['light', 'Claro']] as const).map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => setTone(key)}
            className={`flex-1 rounded-md border px-3 py-2 text-sm transition-colors ${
              tone === key
                ? 'border-ui-accent bg-ui-accent/15 text-ui-text'
                : 'border-ui-border bg-ui-bg text-ui-text-muted hover:border-ui-border-strong'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Transparencia del recuadro */}
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-3">
          <span className="text-sm text-ui-text-muted">Intensidad del recuadro</span>
          <span className="text-sm font-medium text-ui-text">{on ? `${opacity}%` : 'Sin recuadro'}</span>
        </div>
        <input
          type="range"
          min={0}
          max={100}
          step={1}
          value={opacity}
          onChange={(e) => setOpacity(Number(e.target.value))}
          className="w-full accent-ui-accent cursor-pointer"
          aria-label="Intensidad del recuadro detrás del titular"
        />
      </div>
    </motion.div>
  );
}
